const PATH_LOCATION_MAP = {
  'san-francisco': 'San Francisco',
  'walnut-creek': 'Walnut Creek',
  'mountain-view': 'Mountain View',
};

export function normalizeLocationFilters(locations = []) {
  const seen = new Set();

  return locations.reduce((normalized, location) => {
    const value = String(location || '').trim();
    const key = value.toLowerCase();
    if (!value || seen.has(key)) return normalized;
    seen.add(key);
    normalized.push(value);
    return normalized;
  }, []);
}

export function getLocationFiltersFromUrl(search = '', pathname = '') {
  const params = new URLSearchParams(search);
  const queryLocations = normalizeLocationFilters(params.getAll('location'));
  if (queryLocations.length > 0) return queryLocations;

  const lastSegment = String(pathname).split('/').filter(Boolean).pop()?.toLowerCase() || '';
  return PATH_LOCATION_MAP[lastSegment] ? [PATH_LOCATION_MAP[lastSegment]] : [];
}

export function updateLocationFilterSearch(search, locations) {
  const params = new URLSearchParams(search);
  params.delete('location');
  normalizeLocationFilters(locations).forEach((location) => {
    params.append('location', location);
  });

  const query = params.toString();
  return query ? `?${query}` : '';
}

export function appendLocationFilters(params, locations) {
  normalizeLocationFilters(locations).forEach((location) => {
    params.append('location', location);
  });
  return params;
}

export function toggleLocationFilter(locations, location) {
  const normalized = normalizeLocationFilters(locations);
  const key = String(location || '').trim().toLowerCase();
  if (!key) return normalized;

  const isSelected = normalized.some((value) => value.toLowerCase() === key);
  return isSelected
    ? normalized.filter((value) => value.toLowerCase() !== key)
    : [...normalized, String(location).trim()];
}

export function matchesLocationFilters(city, locations) {
  const normalized = normalizeLocationFilters(locations);
  if (normalized.length === 0) return true;

  const cityKey = String(city || '').trim().toLowerCase();
  return Boolean(cityKey) && normalized.some((location) => location.toLowerCase() === cityKey);
}

export function getLocationFilterLabel(locations) {
  const normalized = normalizeLocationFilters(locations);
  if (normalized.length === 0) return 'All Locations';
  return normalized.join(', ');
}
